import { Component, OnInit } from '@angular/core';
import { OrderModel } from '@shared/models/data/order-model';
import { OrderSummaryModel } from '@shared/models/data/order-summary-model';
import { InstitutionSubscriptionModel } from '@shared/models/data/institution-subscription-model';
import { EnrollmentService } from '@shared/services/enrollment.service';
import { SessionService } from '@shared/services/session.service';

@Component({
  selector: 'aaos-app-order-summary-page',
  templateUrl: './order-summary-page.component.html',
  styleUrls: ['./order-summary-page.component.scss']
})
export class OrderSummaryPageComponent implements OnInit {

  institutionId;
  orderSummaryModel: OrderSummaryModel;
  loading = true;
  productsAndOrders = new Map<string, Array<OrderModel>>();
  availableProducts = '';
  hasSubscriptions = false;
  institutionSubscriptions: InstitutionSubscriptionModel[] = [];

  constructor(
    private enrollmentService: EnrollmentService,
    private sessionService: SessionService,
  ) { }


  ngOnInit() {
    this.institutionId = this.sessionService.getInstitutionId();
    this.getInstitutionSubscriptions();
  }

  getInstitutionSubscriptions() {
    this.enrollmentService.getInstitutionSubscriptions(this.institutionId, true).subscribe(subscriptions => {
      this.institutionSubscriptions = subscriptions;
      this.hasSubscriptions = this.institutionSubscriptions.length > 0;
      this.loading = false;
    });
  }


}
